import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <g id="AF" transform="translate(11.5, 25.3)">
          <path
            d="M5,35.7 L10,35.7 L13,26.7 L22,26.7 L25,35.7 L30,35.7 L20,5 L15,5 L5,35.7 Z M14.5,21.7 L20.5,21.7 L17.5,12.7 L14.5,21.7 Z"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          />
          <path d="M20,17.7 L17.5,9.7 L15,17.7 Z" fill="none" />
          <path
            d="M35,35.7 L35,5 L50,5 L50,9.7 L40,9.7 L40,17.7 L48,17.7 L48,22.2 L40,22.2 L40,35.7 L35,35.7 Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
